import { useEffect, useState } from 'react';

import { fetchWeeklyTournaments } from '../../api/tournaments';
import styles from "../../static/styles/RoxESL/RoxLanding.module.css";

const fallbackLiveTournaments = [
    { name: 'PUBG Royale' },
    { name: 'Free Fire Squad' },
    { name: 'Call of Duty Mobile' },
];

const getTournamentName = (tournament) => {
    if (tournament.tourn_name) return tournament.tourn_name;

    switch (tournament.tournament_game) {
        case 'aim_train_001':
            return 'Aim Train';
        case 'cannon_clash_001':
            return 'Cannon Clash';
        default:
            return 'Tournament';
    }
};

const MAX_VISIBLE_TOURNAMENTS = 2;

const RoxFreeEntrySlide = () => {
    const [liveTournaments, setLiveTournaments] = useState(fallbackLiveTournaments);
    const [liveTournamentCount, setLiveTournamentCount] = useState(fallbackLiveTournaments.length);

    useEffect(() => {
        let isMounted = true;

        const loadWeeklyTournaments = async () => {
            try {
                const weeklyData = await fetchWeeklyTournaments();
                const liveData = weeklyData.filter((tournament) => tournament.status === 1 && tournament.is_running !== 1);

                if (!isMounted || liveData.length === 0) return;

                setLiveTournamentCount(liveData.length);
                setLiveTournaments(
                    liveData.slice(0, 3).map((tournament) => ({
                        id: tournament.Id || tournament.id || tournament.tourn_id,
                        name: getTournamentName(tournament),
                        entries: tournament.entries,
                    }))
                );
            } catch (error) {
                if (!isMounted) return;
                setLiveTournaments(fallbackLiveTournaments);
                setLiveTournamentCount(fallbackLiveTournaments.length);
            }
        };

        loadWeeklyTournaments();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <div className={styles.RoxSlide}>
            <span className={styles.RoxFreeEntryBadge}>FREE ENTRY</span>
            <span className={styles.RoxEntryTitle}>UNLIMITED ACCESS</span>
            <p className={styles.RoxEntryMsg}>Premium members enter every tournament<br />zero credits required - ever</p>

            <div className={styles.RoxEntryCompare}>
                <div className={styles.RoxEntryCompareItem}>
                    <span className={styles.RoxEntryCompareLabel}>BASIC</span>
                    <strong>100 credits</strong>
                    <small>per tournament</small>
                </div>
                <div className={styles.RoxEntryCompareDivider} />
                <div className={`${styles.RoxEntryCompareItem} ${styles.RoxEntryComparePremium}`}>
                    <span className={styles.RoxEntryCompareLabel}>PREMIUM</span>
                    <strong>0</strong>
                    <small>per tournament</small>
                </div>
            </div>

            <div className={styles.RoxEntryHeader}>
                <span>LIVE NOW</span>
                <span>{liveTournamentCount} ACTIVE</span>
            </div>

            <div className={styles.RoxTournamentList}>
                {liveTournaments.slice(0, MAX_VISIBLE_TOURNAMENTS).map((tournament) => (
                    <div className={styles.RoxTournamentItem} key={tournament.id || tournament.name}>
                        <div className={styles.RoxTournamentInfo}>
                            <span className={styles.RoxLiveLabel}>LIVE</span>
                            <strong>{tournament.name}</strong>
                        </div>
                        {tournament.entries != null && (
                            <span className={styles.RoxTournamentEntries}>{tournament.entries} entries</span>
                        )}
                        <span className={styles.RoxTournamentFree}>FREE</span>
                    </div>
                ))}
            </div>

            {liveTournamentCount > MAX_VISIBLE_TOURNAMENTS && (
                <span className={styles.RoxTournamentMore}>
                    +{liveTournamentCount - MAX_VISIBLE_TOURNAMENTS} more live now
                </span>
            )}
        </div>
    );
};

export default RoxFreeEntrySlide;
